import { useUi } from "@/core/i18n/locale-context"

interface SkipLinkProps {
  /** `id` of the element that holds the page's main content (WCAG 2.4.1 Bypass Blocks). */
  targetId: string
}

/** First focusable element on the page: hidden until a keyboard user tabs to it. */
export const SkipLink = ({ targetId }: SkipLinkProps) => {
  const ui = useUi()
  return (
    <a
      href={`#${targetId}`}
      className="focus:bg-card focus:text-foreground focus:ring-ring focus:border-border sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:inline-flex focus:min-h-11 focus:items-center focus:rounded-md focus:border focus:px-4 focus:font-medium focus:no-underline focus:ring-2 focus:outline-none"
    >
      {ui.skipToMain}
    </a>
  )
}
